import React, { PropsWithChildren, useMemo } from 'react'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import { Box, Theme, useMediaQuery } from '@mui/material'
import { useLocation } from 'react-router-dom'
import ZIBackground from '../../assets/images/ZI-bg.png'

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
    const { pathname } = useLocation()
    const isWelcomePage = pathname === '/'
    const isDesktop = useMediaQuery((theme: Theme) =>
        theme.breakpoints.up('lg'),
    )
    const showBackground = useMemo(
        () => isDesktop && isWelcomePage,
        [isDesktop, isWelcomePage],
    )

    return (
        <Box className='flex flex-col min-h-screen bg-pantone-white-90'>
            <Box className='container flex-1 px-4 flex flex-col'>
                <Header />
                <main
                    className='flex-1'
                    style={{
                        background: showBackground
                            ? `url('${ZIBackground}') center top 19% / 115% no-repeat`
                            : '',
                    }}
                >
                    <section>{children}</section>
                </main>
            </Box>
            <Footer />
        </Box>
    )
}
export default Layout
